<!--     课件列表 -->
<template>
  <div v-loading="loading">
    <div class="boxlistTit">
      <!-- <Select v-model="param.courseId" placeholder="授课班级">
            <Option :value="0">全部</Option>
            <Option v-for="item in teachingClass" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>-->
      <el-select v-model="param.courseId" placeholder="授课班级">
        <el-option :value="0" label="全部"></el-option>
        <el-option v-for="item in teachingClass" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-input type="name" v-model="param.name" placeholder="课件名称" style="width:280px;margin:0 10px;"></el-input>
      <!-- <Input v-model="param.name" placeholder="课件名称、课程编号"></Input> -->
      <el-button type="primary" @click="getSearchInit">查询</el-button>
      <router-link
        :to="`/teacherManage`"
        style="margin-left:10px"
        class="fr"
      >
        <el-button type="primary">返回</el-button>
      </router-link>
      <router-link
        :to="`/alliance/teacher/${$route.query.schoolId}/courseware/upload?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}`"
      >
        <el-button type="primary" class="fr">上传</el-button>
      </router-link>
      <el-button
        type="primary"
        class="fr"
        style="margin-right:12px"
        @click="delCourse({courseWareName:'所有课件'},false)"
        :disabled="!multipleSelection.length>0"
      >批量删除</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="coursewareList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="courseWareName" label="课件名称"></el-table-column>
      <el-table-column prop="size" label="大小(kb)"></el-table-column>
      <el-table-column prop="createdDate" label="上传时间"></el-table-column>
      <el-table-column label="可见授课班级">
        <template slot-scope="{ row }">
          <span
            v-for="(item,idx) in row.courseList"
            :key="idx"
          >{{row.courseList.length==idx+1?item:item+'、'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="courseWareId" label="课件编号"></el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <span v-html="scope.row.remark"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="small" @click="editClass(scope)">修改可见班级</el-button>
            <el-button size="small" @click="download(scope.row)">下载</el-button>
            <el-button type="danger" size="small" @click="delCourse(scope.row,true)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="foot-pager"
      :page-size="10"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="param.startIndex"
      @current-change="getSearchInit"
    ></el-pagination>

    <el-dialog
      v-loading="loading"
      title="提示"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      @opened="openCallBack"
      width="1000px"
    >
      <visibleClass :getCourseWare="getCourseWare" :getCourse="getCourse" ref="openCallBack"></visibleClass>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="compile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import visibleClass from "../common/visibleClass";
export default {
  components: { visibleClass },
  data() {
    return {
      getCourse: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      getCourseWare: {
        courseWareId: 0,
        schoolId: this.$route.query.schoolId,
      },
      dialogVisible: false,
      teachingClass: [], // 授课列表
      paramSummary: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      multipleSelection: [],
      loading: false,
      total: 0,
      param: {
        courseId: 0,
        name: "",
        showItem: 10,
        schoolId: this.$route.query.schoolId,
        pageIndex: 1,
        teacherId: this.$route.query.teacherId,
      },
      coursewareList: [],
    };
  },
  created() {
    this.getSearchInit();
    this.getCourseSummaryList();
  },
  methods: {
    // 下载
    download(item) {
      const param = {
        schoolId: this.$route.query.schoolId,
        courseWareId: item.courseWareId,
      };
      this.$api.allianceSchool
        .getCourseWareAttachmentList(param)
        .then((res) => {
          if (res.errCode == 0) {
            window.location.href = res.data[0].url;
          } else {
            this.$message.error(res.errMsg);
          }
        });
    },
    // 删除
    delCourse(item, type) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          schoolId: this.$route.query.schoolId,
          wareIds: [],
        };
        param.wareIds = [];
        if (type) {
          param.wareIds.push(item.courseWareId);
        } else {
          this.multipleSelection.forEach((items, idx) => {
            param.wareIds.push(items.courseWareId);
          });
        }
        this.$api.allianceSchool.delCourseWare(param).then((res) => {
          if (res.errCode == 0) {
            this.param.startIndex = 1;
            this.getSearchInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 确认修改可见
    compile() {
      const param = {
        courseIds: this.$refs.openCallBack.checkedCities,
        courseWareId: this.$refs.openCallBack.getCourseWare.courseWareId,
        schoolId: this.$refs.openCallBack.getCourseWare.schoolId,
      };
      this.loading = true;
      this.$api.allianceSchool
        .updateCourseWareShareList(param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.dialogVisible = false;
            this.getSearchInit();
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 模态框回调
    openCallBack() {
      this.$refs.openCallBack.coursewareInit();
    },
    // 编辑
    editClass(item) {
      this.getCourseWare.courseWareId = item.row.courseWareId;
      this.dialogVisible = true;
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool
        .getCourseSummaryList(this.paramSummary)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.teachingClass = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 复选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getSearchInit() {
      this.loading = true;
      this.$api.allianceSchool
        .getCourseWareList(this.param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.coursewareList = res.data.items;
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang='less' scoped>
.foot-pager {
  text-align: center;
}
</style>